import { getBankInfo } from "shared/services/api/bancos.api";
import { IConta } from "../../interfaces/IConta";


/* =========================================
   CONVERTE TIPO DA API PARA O FORMULÁRIO
========================================= */

const mapearTipoConta = (tipo: string): string => {
  switch (tipo) {
    case "checking":
      return "corrente";
    case "savings":
      return "poupanca";
    default:
      return tipo;
  }
};

export function mapDadosBancarios(dados: {
  bankCode: string;
  branch: string;
  branchDigit?: string | null;
  account: string;
  accountDigit?: string | null;
  type: string;
  holderName?: string | null;
  holderDocument?: string | null;
  kycStatus?: string;
  kycStatusReason?: string | null;
  gatewayStatus?: string;
}): IConta {
  const detalhesBanco = getBankInfo(dados.bankCode);

  return {
    id: 0,

    /* =======================================
       TITULAR
    ======================================= */

    holderName: dados.holderName ?? "",
    holderDocument: dados.holderDocument ?? "",

    /* =======================================
       TIPO DA CONTA
    ======================================= */

    tipoConta: mapearTipoConta(dados.type),

    /* =======================================
       BANCO
    ======================================= */

    banco: {
      nome: detalhesBanco?.nome ?? "",
      logo: detalhesBanco?.logo ?? "",
      codigo: dados.bankCode,
    },

    /* =======================================
       AGÊNCIA
    ======================================= */

    agencia: dados.branchDigit ? `${dados.branch}-${dados.branchDigit}` : dados.branch,

    /* =======================================
       CONTA
    ======================================= */

    numeroConta: dados.accountDigit ? `${dados.account}-${dados.accountDigit}` : dados.account,

    /* =======================================
       KYC
    ======================================= */

    kycStatus: dados.kycStatus,
    kycStatusReason: dados.kycStatusReason,
    gatewayStatus: dados.gatewayStatus,
  };
}